import { Hex } from "viem"
import {
  TransactionItemBase,
  TransactionItemUnion,
  TransactionLabel,
} from "./baseTransactionTypes"

export type TosTransaction = {
  label: TransactionLabel.TOU
  hash: Hex
  message: string
}

export type TosTransactionItem = TransactionItemBase<TosTransaction>

export function isTosTransactionItem(
  transaction?: TransactionItemUnion,
): transaction is TosTransactionItem {
  return transaction?.label === TransactionLabel.TOU
}
